import React from 'react';
import ArrowBack from '@material-ui/icons/ArrowBackIos';
import ArrowForward from '@material-ui/icons/ArrowForwardIos';
import {PaginationArrowProps} from 'react-daterange-picker';

export default function DaterangeArrows({onTrigger, direction}: PaginationArrowProps) {
    if (direction === 'previous') {
        return (
            <ArrowBack
                className="DateRangePicker-nav DateRangePicker-nav-prev"
                onClick={onTrigger}
            />
        );
    }
    
    return (
        <ArrowForward
            className="DateRangePicker-nav DateRangePicker-nav-next"
            onClick={onTrigger}
        />
    );
}
